import React, { useState, useEffect, useContext } from "react";
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import LoaderAnimation from "pages/LoaderAnimation";
import { useTheme } from '@mui/material/styles';
import { apiGet, apiPost } from "app/Services/ApiService";
import { contractorApiUrls } from "common/ApiUrls";
import { Utils } from "common/Utils";
import { PortalNames } from "common/Portals";
import moment from "moment";
import AximTooltip from "components/AximTooltip";
import CurrencyFormatter from "components/Formatter/CurrencyFormatter";
import PublishOutlinedIcon from '@mui/icons-material/PublishOutlined';
import TableStyle from "components/Content/Table/TableStyle.module.css";
import TableAllData from "components/Content/CustomTable/TableAllData";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import CheckIcon from '@mui/icons-material/Check';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import HistoryIcon from '@mui/icons-material/History';
import ContractorFileUploadsDialog from "components/Content/Modal/ContractorFileUploadsDialog";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Slide,
    IconButton,
    Box,
    Grid
} from "@mui/material";

import ButtonStyle from "components/Button/ButtonStyle.module.css";

import _ from 'lodash';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function Contracts() {
    const [contractList, setContractList] = useState([]);
    const availableUploadTypes = ['1E870BF5-860A-4EE5-B25A-43F3499A6C8B', '611D6077-94D4-4682-A367-B92573B8811C'];
    const [hasLoadError, setHasLoadError] = useState(false);
    const [changeLogSinceAck, setChangeLogSinceAck] = useState([]);
    const [showAckButton, setShowAckButton] = useState(false);
    const [showAckBy, setShowAckBy] = useState(false);
    const [checkingData, setCheckingData] = useState(false)
    const [columnsArray, setColumnsArray] = useState([]);
    const [fetchedData, setFetchedData] = useState([]);
    const [openModal, setOpen] = useState(false);
    const [openContractModal, setOpenContractModal] = useState(false);
    const [contractRates, setContractRates] = useState([]);
    const [currentContract, setCurrentContract] = useState(null);
    const [savingData, setSavingData] = useState(false);
    const [loadingData, setLoadingData] = useState(false);
    const [fileUploadModal,setFileUploadModal] = useState(false);
    const theme = useTheme();
    let changeLogs = []
    const handleClose = () => {
        setOpen(false)
        setOpenContractModal(false)
    };

    const fetchContracts = (event) => {
        console.log('fetching contracts')
        setCheckingData(true);
        apiGet(contractorApiUrls.getContracts())
            .then((response) => {
                console.log('fetch contracts')
                console.dir(response)
                setFetchedData(response.data);
            })
            .catch(function (error) {
                // console.log("THIS IS ERROR", error);          
                setColumnsArray([]);
                setFetchedData([]);
            })
            .then(function () {
                // always executed
                setCheckingData(false);
            });
    };

    const acknowledgeContractChanges = (contractId) => {
        setSavingData(true)
        console.log('acknowledgeContractChanges', contractId)
        apiPost(contractorApiUrls.postAcknowledgeChanges(contractId))
            .then((response) => {
                console.log('post acknowledage contracts')
                console.dir(response)
                fetchContracts()
                setSavingData(false)
                setShowAckButton(false)
                setOpen(false)
            })
            .catch(function (error) {
                // console.log("THIS IS ERROR", error);          
            })
            .then(function () {
                setSavingData(false)
            });
    };

    const parseChanges = (changes) => {
        let changeList = []
        const changeObj = JSON.parse(changes);
        if (changeObj.OldValue == "") {
            // changeList.push(`New`)
            for (const [key, value] of Object.entries(changeObj.NewValue)) {
                if (key != 'UpdateDate' && key != 'UpdateUserName' && key.slice(-2) != "Id") {
                    //console.log(`${key}: ${value}`);
                    if (key.slice(-4) == "Date") {
                        changeList.push(`${_.startCase(key)} : ${Utils.formatDate(value)} `)
                    }
                    else {
                        if (key != 'CreateUserName') {
                            changeList.push(`${_.startCase(key)} : ${value}`)
                        }
                    }
                }
            }
        }
        if (changes.OldValue != "" && changes.NewValue != "") {
            const oldVal = changeObj.OldValue;
            const newVal = changeObj.NewValue;
            for (const [key, value] of Object.entries(newVal)) {
                if (key != 'UpdateDate' && key != 'UpdateUserName' && key.slice(-2) != "Id") {
                    //console.log(`${key}: ${value}`);
                    if (oldVal[key] !== undefined && oldVal[key] != value) {
                        if (key.slice(-4) == "Date") {
                            changeList.push(`${_.startCase(key)} changed from ${Utils.formatDate(oldVal[key])} to ${Utils.formatDate(value)}`)
                        }
                        else {
                            changeList.push(`${_.startCase(key)} changed from ${oldVal[key]} to ${value}`)
                        }
                    }
                }
            }
        }
        return changeList;
    }

    const fetchPendingChanges = (contractId) => {
        console.log('fetching contract changes')
        setLoadingData(true)
        apiGet(contractorApiUrls.getPendingContractChanges(contractId))
            .then((response) => {
                console.log('fetch pending contract changes')
                console.dir(response)
                setChangeLogSinceAck(response.data)
                setLoadingData(false)
                setShowAckButton(true)
            })
            .catch(function (error) {
                console.log("THIS IS ERROR", error);

            })
            .then(function () {
                // always executed
                setLoadingData(false)
            })
    }


    const fetchAllChanges = (contractId) => {
        console.log('fetching contract changes')
        setLoadingData(true)
        setShowAckButton(false)
        apiGet(contractorApiUrls.getAllContractChanges(contractId))
            .then((response) => {
                console.log('fetch pending contract changes')
                console.dir(response)
                setChangeLogSinceAck(response.data)
                setLoadingData(false)
            })
            .catch(function (error) {
                console.log("THIS IS ERROR", error);

            })
            .then(function () {
                // always executed
                setLoadingData(false)
            })
    }
    const fetchChanges = (contractId, showAllChanges) => {
        console.log('fetching contract changes')
        apiGet(contractorApiUrls.getContractChanges(contractId, showAllChanges))
            .then((response) => {
                console.log('fetch contract changes')
                console.dir(response)
                // let changeLogs = []
                if (response.data.length == 0) {
                    setChangeLogSinceAck([])
                }
                else {
                    parseChanges(response)
                }
            })
            .catch(function (error) {
                console.log("THIS IS ERROR", error);

            })
            .then(function () {
                // always executed
            })
    }


    let contractRateColumns = [
        {
            Header: "Contract Name",
            accessor: "contractName",
        },
        {
            Header: "Begin Date",
            accessor: (cell) => Utils.formatDate(cell.beginDate),
            Cell: ({ row }) => (
                <Box>
                    {Utils.formatDate(row.original.beginDate)}
                </Box>
            ),
            sortType: "dateSort",
        },
        {
            Header: "End Date",
            accessor: (cell) => Utils.formatDate(cell.endDate),
            Cell: ({ row }) => (
                <Box>
                    {Utils.formatDate(row.original.endDate)}
                </Box>
            ),
            sortType: "dateSort",
        },
        {
            Header: "Rate",
            accessor: (cell) => <CurrencyFormatter value={cell.rate} />
        }
    ]

    const fetchContract = (contractId) => {
        console.log('fetching contract')
        apiGet(contractorApiUrls.getContract(contractId))
            .then((response) => {
                console.log('fetch contract ')
                console.dir(response)
                setContractRates(response.data)
            })
            .catch(function (error) {
                console.log("THIS IS ERROR", error);

            })
            .then(function () {
                // always executed
            })
    }

    const viewChanges = (contractId) => {
        console.log('view changes')
        setShowAckButton(true)
        setShowAckBy(false)
        changeLogs = []
        setChangeLogSinceAck([])
        setCurrentContract(contractId)
        fetchPendingChanges(contractId)
        setOpen(true)
    }

    const viewAllChanges = (contractId) => {
        console.log('view all changes')
        setShowAckButton(true)
        setShowAckBy(true)
        changeLogs = []
        setCurrentContract(contractId)
        setChangeLogSinceAck([])
        setLoadingData(true)
        fetchAllChanges(contractId)
        setOpen(true)
    }

    const viewContract = (contractId) => {
        setOpenContractModal(true)
        setContractRates([])
        fetchContract(contractId)
    }

    const openFileUpload = (cell) => {
        setContractList([cell])
        setFileUploadModal(true)
    }

    useEffect(() => {
        setColumnsArray(columns)
        fetchContracts()
    }, [])

    let columns = [
        {
            Header: "Action",
            accessor: (cell) => (
                <>
                    <AximTooltip title="All Changes" disableFocusListener>
                        <IconButton color="primary" aria-label="View" component="span"
                            onClick={() => viewAllChanges(cell.primeSubContractID)}
                        >
                            <HistoryIcon />
                        </IconButton>
                    </AximTooltip>
                    <AximTooltip title="Upload document" disableFocusListener>
                        <IconButton color="primary" aria-label="View" component="span"
                            onClick={() => openFileUpload(cell)}
                        >
                            <PublishOutlinedIcon />
                        </IconButton>
                    </AximTooltip>
                </>
            ),
            disableFilters: true,
        },
        {
            Header: "Contract Name",
            accessor: "contractName",
        },
        {
            Header: "Contract Code",
            accessor: "contractCode",
        },
        {
            Header: "Begin Date",
            accessor: (cell) => (
                <>
                    {Utils.formatDate(cell.beginDate)}
                </>),
        },
        {
            Header: "End Date",
            accessor: (cell) => (
                <>
                    {Utils.formatDate(cell.endDate)}
                </>),
        },
        {
            Header: "Rate",
            accessor: "rate",
            Cell: ({ row }) => (<CurrencyFormatter value={row.original.rate} />),
        },
        {
            Header: "Changed",
            accessor: (cell) => (
                <>
                    {cell.changed ?
                        <AximTooltip title="Changes Since Last Acknowledgement" disableFocusListener>
                            <IconButton color="primary" aria-label="View" component="span"
                                onClick={() => viewChanges(cell.primeSubContractID)}
                            >
                                <WarningAmberIcon></WarningAmberIcon>
                            </IconButton>
                        </AximTooltip> : <></>}
                </>),
        }
    ];

    const childContract = (row, rowProps, visibleColumns) => {
        if (row.row.original.children.length == 0) {
            return <></>
        }
        return (
            row.row.original.children.map((c, idx) => {
                return <Grid container>
                    <Grid item sm={7}>
                    </Grid>
                    <Grid item sm={1}>
                        <AximTooltip title="History" disableFocusListener>
                            <IconButton color="primary" aria-label="Users" component="span"
                                onClick={() => { viewAllChanges(c.primeSubContractID) }} >
                                <HistoryIcon />
                            </IconButton>
                        </AximTooltip>
                        <AximTooltip title="Upload document" disableFocusListener>
                            <IconButton color="primary" aria-label="View" component="span"
                            onClick={() => openFileUpload(c)}
                            >
                                <PublishOutlinedIcon />
                            </IconButton>
                        </AximTooltip>
                    </Grid>
                    <Grid item sm={4}>
                        <Grid container>
                            <Grid item sm={4}> {Utils.formatDate(c.beginDate)}
                            </Grid>
                            <Grid item sm={4}> {Utils.formatDate(c.endDate)}
                            </Grid>
                            <Grid item sm={4}><CurrencyFormatter value={c.rate} />
                                {c.changed ?
                                    <AximTooltip title="Changes Since Last Acknowledgement" disableFocusListener>
                                        <IconButton color="primary" aria-label="View" component="span"
                                            onClick={() => viewChanges(c.primeSubContractID)}
                                        >
                                            <WarningAmberIcon></WarningAmberIcon>
                                        </IconButton>
                                    </AximTooltip> : <></>}
                        </Grid>
                    </Grid>
                </Grid>
                </Grid >
            })
        )
    }

const renderChanges = (cell) => {
    if (cell.operation == 'UPDATE') {
        return (
            cell.changes ?
                <table className="table">
                    <thead style={{ "font-weight": "bold" }}><tr><td></td><td>Old</td><td>New</td></tr></thead>
                    <tbody>
                        {cell.changes.map((obj, i) => <tr key={i}><td>{obj.name}</td> <td>{obj.old}</td><td>{obj.new}</td></tr>)}
                    </tbody>

                </table> : <></>)
    }
    else if (cell.operation == 'INSERT') {
        return (
            <table className="table">
                <thead style={{ "font-weight": "bold" }}><tr><td></td><td>New</td></tr></thead>
                <tbody>
                    {cell.changes.map((obj, i) => <tr key={i}><td>{obj.name}</td><td>{obj.new}</td></tr>)}
                </tbody>
            </table>)
    }
    else if (cell.operation == 'DELETE') {
        return (
            cell.changes ?
                <table className="table">
                    <thead style={{ "font-weight": "bold" }}><tr><td></td><td>Old</td></tr></thead>
                    <tbody>
                        {cell.changes.map((obj, i) => <tr key={i}><td>{obj.name}</td> <td>{obj.old}</td></tr>)}
                    </tbody>

                </table> : <></>)
    }
}

const convertStatus = (status) => {
    switch (status) {
        case 2:
            return 'Acknowledged';
        case 1:
            return 'Pending';
        default:
            return '';
    }
}

let changeLogColumnsArray = [
    {
        Header: "Update Date",
        accessor: (cell) => (Utils.formatDate(cell.updateDate))
    },
    {
        Header: "Status",
        //accessor: (cell) => <span>{cell.statusID}</span>,
        accessor: "statusID",
        Cell: ({ row }) => convertStatus(row.original.statusID),
    },
    {
        Header: "Change",
        accessor: (cell) => (
            <Box>
                <ul>{parseChanges(cell.changes).map(c => { return <li>{c}</li> })}</ul>
            </Box>
        ),
    },
];

const options = {
    filter: true,
    filterType: "dropdown",
    responsive: "standard",
    viewColumns: true,
    download: false,
    print: false,
    textLabels: {
        body: {
            noMatch:
                fetchedData !== undefined ? (
                    <LoaderAnimation />
                ) : (
                    "Sorry, there is no data to show"
                ),
        },
    },
    searchProps: { variant: "standard" }
};

return (
    <>
        {/* Add Contract MODAL */}
        <Dialog
            open={openModal}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
            className={TableStyle.fileTypeModalWrapper}
            fullWidth
            maxWidth="lg"            >
            <DialogTitle id="alert-dialog-slide-title">
                Contract Changes
            </DialogTitle>
            <DialogContent>
                <Box
                    component="form"
                    sx={{
                        '& .MuiTextField-root': { m: 1, width: '25ch' },
                    }}
                    noValidate
                    autoComplete="off"
                >
                    <div>
                        {((!loadingData && changeLogSinceAck.length == 0) ? "No Change" : <TableAllData
                            className={TableStyle.TimeSheetsWrapper}
                            columns={changeLogColumnsArray}
                            data={changeLogSinceAck}
                            isLoading={loadingData}
                        />)}
                    </div>
                </Box>
            </DialogContent>
            <DialogActions className={ButtonStyle.buttonWrapper}>
                {(showAckButton && changeLogSinceAck && changeLogSinceAck.length > 0) ?
                    <Button
                        variant="outlined"
                        onClick={() => acknowledgeContractChanges(currentContract)}
                        disabled={savingData}
                    >
                        Acknowledge Changes
                    </Button> : <></>}
                <Button onClick={handleClose} className={ButtonStyle.CcancelBtn}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>


        {/* view Contract MODAL */}
        <Dialog
            open={openContractModal}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
            className={TableStyle.fileTypeModalWrapper}
            fullWidth
            maxWidth="lg"            >
            <DialogTitle id="alert-dialog-slide-title">
                Contract
            </DialogTitle>
            <DialogContent>
                <Box
                    component="form"
                    sx={{
                        '& .MuiTextField-root': { m: 1, width: '25ch' },
                    }}
                    noValidate
                    autoComplete="off"
                >
                    <div>
                        <TableAllData
                            className={TableStyle.TimeSheetsWrapper}
                            columns={contractRateColumns}
                            data={contractRates}
                        />
                    </div>
                </Box>
            </DialogContent>
            <DialogActions className={ButtonStyle.buttonWrapper}>
                <Button onClick={handleClose} className={ButtonStyle.CcancelBtn}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>

        <TableAllData
            className={TableStyle.TimeSheetsWrapper}
            columns={columnsArray}
            data={fetchedData}
            renderRowSubComponent={childContract}
            isAlwaysExpanded={true}
        />
  
        <ContractorFileUploadsDialog openModal={fileUploadModal}
                                handleClose={() => setFileUploadModal(false)}
                                //getUserUploads={getUserUploads}
                                availableUploadTypes={availableUploadTypes}
                                contractList={contractList} />
    </>
);
}

export default Contracts;
